// extracted by mini-css-extract-plugin
export var text = "_3f-0";